<template>
    <div class="item" :class="'item' + menu.idx">
        <a :href="menu.url" :target="menu.target">
        <div class="circle" :class="'circle' + menu.idx">
            <div class="system" v-for="(t, i) in menu.title" :key="i">{{t}}</div>
            <div class="link" v-for="(l, i) in menu.link" :key="i">{{l}}</div>
        </div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "CircleMenu",
        props: {
            menu: Object
        }
    }
</script>

<style scoped>
    .circle {
        width: 170px;
        height: 170px;
        border-radius: 50%;
        border: 5px solid #000;
        background-color: #fff;
        display: table-cell;
        vertical-align: middle;
        cursor: pointer;
        transition: .3s all;
    }

    .circle:hover {
        transform: scale(1.05);
    }

    .system, .link {
        font-size: 1.2rem;
        font-weight: 500;
    }

    .system {

    }

    .link {
        color: #2a2d30;
    }

    .circle0 {
        border-color: #0b4a94;
        color: #0b4a94;
    }

    .circle1 {
        border-color: #b3c415;
        color: #596a2f;
    }

    .circle2 {
        border-color: #14b0c8;
        background-color: #14b0c8;
        color: #fff;
    }

    .item0, .item1, .item2 {
        text-align: -webkit-center;
    }

    .circle div {
        transition: .3s all;
    }

    @media screen and (min-width: 950px) {
        .item0, .item1 {
            width: 20%;
            display: inline-block;
        }

        .item2 {
            margin-top: -20px;
        }
    }

    @media screen and (max-width: 949px) {
        .item0, .item1 {
            width: 100%;
            display: inline-block;
        }

        .item2 {
            margin-top: 0px;
        }

        .circle {
            margin-bottom:10px;
            border-radius: 0;
            width:90%;
            display:block;
            height:auto;
            padding:10px 0;
        }

        .circle div {
            display:inline-block;
        }
    }

    a:link {
        text-decoration: none;
    }

    a:visited {
        text-decoration: none;
    }

    a:hover {
        text-decoration: none;
    }

    a:active {
        text-decoration: none;
    }

</style>